<template>
  <div
    id="main_container"
    class="main-container d-flex flex-column flex-grow-1"
    :style="userColors"
  >
    <editCategory
      class="d-flex flex-grow-1"
      v-if="activeModal == 'editCategory' && isMenuOwner"
    />
    <addCategory
      class="d-flex flex-grow-1"
      v-if="activeModal == 'addCategory' && isMenuOwner"
    />
    <addItem
      class="d-flex flex-grow-1"
      v-if="activeModal == 'addItem' && isMenuOwner"
    />
    <editItem
      class="d-flex flex-grow-1"
      v-if="activeModal == 'editItem' && isMenuOwner"
    />
    <viewItem
      class="d-flex flex-grow-1"
      v-if="activeModal == 'viewItem'"
    />
    <editMenuItemOptions
      class="d-flex flex-grow-1"
      v-if="activeModal == 'editMenuItemOptions' && isMenuOwner"
    />
    <editMenuItemCrossSellGroups
      class="d-flex flex-grow-1"
      v-if="activeModal == 'editMenuItemCrossSellGroups' && isMenuOwner"
    />
    <guestRegister
      class="d-flex flex-grow-1"
      v-if="activeModal == 'guestRegister'"
      v-bind:dineInIntent="dineInIntent"
      v-on:dine-in-intent="updateDineInIntent"
    />
    <contactUser
      class="d-flex flex-grow-1"
      v-if="activeModal == 'contactUser'"
    />
    <claimMenu
      class="d-flex flex-grow-1"
      v-if="activeModal == 'claimMenu'"
    />
    <subscribeCustomer
      class="d-flex flex-grow-1"
      v-if="activeModal == 'subscribeCustomer'"
    />
    <unSubscribeCustomer
      class="d-flex flex-grow-1"
      v-if="activeModal == 'unSubscribeCustomer'"
    />
    <aboutUser
      class="d-flex flex-grow-1"
      v-if="activeModal == 'aboutUser'"
    />

    <viewOrder
      class="d-flex flex-grow-1"
      v-if="activeModal == 'customerCart' && onlineMenuEnabled"
    />

    <div
      ref="header"
      v-if="!this.mockMenu"
    >
      <sharedHeader />
    </div>
    <div
      class="d-flex flex-column flex-grow-1 menu-container"
      v-if="menu && !appProcessing"
    >
      <div
        class="bg-white mb-lg-3 pb-lg-3 menu-header"
        v-bind:class="{ 'sticky-header': stickyHeader }"
        ref="stickyHeader"
      >
        <div class="container-sm">
          <menuTitle :menu="menu" />
        </div>
        <menuFunctions
          :menu="menu"
          v-if="!this.mockMenu"
        />
        <menuNavigation
          v-if="menu.user.is_subscribed || menu.user.is_on_trial || menu.user.type==1"
          :menu="menu"
          :selectedCategory="selectedCategory"
          @scrollTo="scrollTo"
        />
        <menuFilters
          v-if="menu.user.is_subscribed || menu.user.is_on_trial || menu.user.type==1"
          :menu="menu"
          @updateFilters="updateFilters"
        />
      </div>

      <div
        class="container-sm"
        v-bind:class="{
          cmp: stickyHeader,
        }"
        id="topOfMenu"
      >
        <div v-if="menu.user.is_subscribed || menu.user.is_on_trial || menu.user.type==1">
          <draggable
            v-model="menu.categories"
            :disabled="!isMenuOwner"
            @update="handleCategorySort"
            :delay="70"
            :delayOnTouchOnly="true"
            ghostClass="menu-category-ghost"
            chosenClass="menu-category-chosen"
          >
            <menuCategory
              v-for="category in menu.categories"
              v-bind:key="'ct-' + category.id"
              v-bind:data-slug="category.slug"
              v-bind:id="categoryIdPrefix + category.slug"
              :menu="menu"
              :category="category"
              :mockMenu="mockMenu"
              v-bind:data-category="category.slug"
            />
          </draggable>
        </div>
        <div v-if="!menu.user.is_subscribed && !menu.user.is_on_trial && menu.user.type!=1">
          <div
            class="text-center"
            v-if="isMenuOwner"
          >
            <router-link
              class="font-weight-bold"
              :to="{
                name: 'paymentMethod',
                params: { userSlug: menu.user.slug },
              }"
            >
              Click to update payment method to resume services</router-link>
          </div>
          <div v-else>
            <h3 class="text-center">Menu is not available</h3>
          </div>
        </div>

        <div
          class="text-center h-100 d-flex align-items center justify-content-center"
          v-if="rawMenu.categories.length && !menu.categories.length"
        >
          <div>
            <div
              class="mb-5"
              v-for="(category, index) in rawMenu.categories"
              :key="index"
            >
              <div v-if="category.is_time_restricted == 1">
                <h3>
                  {{ category.name }} menu displays from
                  {{ category.time_from | friendlyTime }}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div>
          <section class="mt-5">
            <h1 class="mb-0">
              {{ menu.user.name }}
            </h1>
            <div class="mb-4">
              <span
                v-for="(cuisine, index) in rawMenu.user.cuisines"
                class="font-weight-bold mr-3"
                :key="'c' + index"
              >#{{ cuisine.label }} Cuisine <span v-if="rawMenu.user.address_neighborhood_name">{{
                  rawMenu.user.address_neighborhood_name
                }}</span>
                <span v-if="rawMenu.user.address_city_name">{{
                  rawMenu.user.address_city_name
                }}</span></span>
            </div>
            <address>
              <div class="font-family-1 text-muted">

                <span v-if="rawMenu.user.address_street_name">{{
                  rawMenu.user.address_street_name
                }}</span>
              </div>

              <div
                v-if="rawMenu.user.address_neighborhood_name"
                class="font-family-1 text-muted"
              >
                {{ rawMenu.user.address_neighborhood_name }}
              </div>
              <div
                v-if="rawMenu.user.address_city_name"
                class="font-family-1 text-muted"
              >
                {{ rawMenu.user.address_city_name }}
              </div>
              <div
                v-if="rawMenu.user.state.name"
                class="font-family-1 text-muted"
              >
                {{ rawMenu.user.state.name}}
              </div>
              <div
                v-if="rawMenu.user.address_zip"
                class="font-family-1 text-muted"
              >
                {{ rawMenu.user.address_zip }}
              </div>
              <div
                v-if="rawMenu.user.address_county_name"
                class="font-family-1 text-muted"
              >
                {{ rawMenu.user.address_county_name }}
              </div>
              <div
                v-if="rawMenu.user.address_street_name"
                class="font-family-1 text-muted"
              >
                {{ rawMenu.user.country.name }}
              </div>
              <div
                v-if="rawMenu.user.address_notes"
                class="font-family-1"
              >
                Direction notes:
                <span class="text-muted">({{ rawMenu.user.address_notes }})</span>
              </div>
            </address>

            <div
              v-if="rawMenu.user.phone"
              class="mt-1 font-weight-bold"
            >
              <a :href="'tel:' + rawMenu.user.phone">{{ rawMenu.user.phone }}</a>
            </div>
            <div class="mt-1">
              <a
                v-if="rawMenu.user.website_url"
                :href="validWebsiteUrl"
                target="_blank"
              >{{ rawMenu.user.website_url }}</a>
            </div>

            <iframe
              v-if="mapSource"
              :src="mapSource"
              class="mt-4 user-location"
              width="100%"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>

            <div class="accordion-items">
              <div
                class="accordion-item"
                v-if="rawMenu.user.show_sms_marketing_form"
              >
                <div
                  class="accordion-item-header"
                  @click="
                    $router.push({
                      name: 'menuSubscribe',
                      params: { userSlug: menu.user.slug },
                    })
                  "
                >
                  <h3>Deals, Discounts & Coupons</h3>
                  <i class="fa fa-arrow-right"></i>
                </div>
              </div>
              <div
                class="accordion-item"
                v-if="rawMenu.user.about_text"
              >
                <div
                  class="accordion-item-header"
                  @click="
                    $router.push({
                      name: 'menuAbout',
                      params: { userSlug: menu.user.slug },
                    })
                  "
                >
                  <h3>About us</h3>
                  <i class="fa fa-arrow-right"></i>
                </div>
              </div>
              <div
                class="accordion-item"
                v-if="rawMenu.user.contact_email"
              >
                <div
                  class="accordion-item-header"
                  @click="
                    $router.push({
                      name: 'menuContact',
                      params: { userSlug: menu.user.slug },
                    })
                  "
                >
                  <h3>Contact us</h3>
                  <i class="fa fa-arrow-right"></i>
                </div>
              </div>
              <div
                class="accordion-item"
                :class="{ 'accordion-item-open': accordionItems.openingHours.open }"
                v-if="
                  isValidJson(menu.user.show_business_hours && menu.user.business_hours)
                "
              >
                <div
                  class="accordion-item-header"
                  @click="toggleAccordionItem(accordionItems.openingHours)"
                >
                  <h3>Operating hours</h3>
                  <i class="fa fa-chevron-down"></i>
                </div>
                <Transition
                  enter-active-class="animate__animated animate__slideInDown"
                  leave-active-class="animate__animated animate__slideOutUp"
                >
                  <div
                    class="accordion-item-content"
                    v-if="accordionItems.openingHours.open"
                  >
                    <openingHours />
                  </div>
                </Transition>
              </div>
              <div
                class="accordion-item"
                v-if="rawMenu.user.table_reservation_url"
              >
                <a
                  class="accordion-item-header"
                  :href="rawMenu.user.table_reservation_url"
                  target="_blank"
                >
                  <h3>Reserve a table</h3>
                  <i class="fa fa-arrow-right"></i>
                </a>
              </div>

              <div
                class="accordion-item"
                v-if="menu.categories.length && menu.categories.length > 2"
              >
                <div
                  class="accordion-item-header"
                  @click="toggleAccordionItem(accordionItems.shareMenu)"
                >
                  <h3>Share menu</h3>
                  <i class="fa fa-chevron-down"></i>
                </div>

                <Transition
                  enter-active-class="animate__animated animate__slideInDown"
                  leave-active-class="animate__animated animate__slideOutUp"
                >
                  <div
                    class="accordion-item-content"
                    v-if="accordionItems.shareMenu.open"
                  >
                    <socialShare />
                  </div>
                </Transition>
              </div>
              <div
                class="accordion-item"
                :class="{ 'accordion-item-open': accordionItems.reviews.open }"
                v-if="menu.user.show_reviews && menu.user.reviews.length"
              >
                <div
                  class="accordion-item-header"
                  @click="toggleAccordionItem(accordionItems.reviews)"
                >
                  <h3>Reviews <span class="r-scr">{{reviewScore}}/5</span></h3>
                  <i class="fa fa-chevron-down"></i>
                </div>
                <Transition
                  enter-active-class="animate__animated animate__slideInDown"
                  leave-active-class="animate__animated animate__slideOutUp"
                >
                  <div
                    class="accordion-item-content"
                    v-if="accordionItems.reviews.open"
                  >
                    <reviews />
                  </div>
                </Transition>
              </div>
            </div>
            <section>
              <gallery v-if="rawMenu.user.media" />
            </section>
            <div class="mt-3 text-center">
              <socialLinks />
            </div>
          </section>

        </div>
      </div>
    </div>
    <div
      v-if="appProcessing"
      class="w-100 vh-100 d-flex align-items-center justify-content-center app-processing"
    >
      <formLoader></formLoader>
    </div>
    <sharedFooter
      v-if="!appProcessing && !this.mockMenu"
      v-bind:user="user"
      class="mt-5"
    ></sharedFooter>
    <cartButton v-if="!user.id"></cartButton>
    <orderSuccessNotification></orderSuccessNotification>
    <feedBackForm
      v-if="
        menu &&
        menu.user.enable_feedback &&
        cart.receipt_email &&
        'feedback_sent' in cart &&
        cart.feedback_sent === false
      "
      :menu="menu"
      :email="cart.receipt_email"
    ></feedBackForm>
  </div>
</template>

<style scoped lang="scss">
::v-deep a {
  color: var(--user-highlight-color);
}
::v-deep .btn-link {
  color: var(--user-highlight-color);
}
::v-deep a:not([href]) {
  color: inherit;
  text-decoration: none;
}
::v-deep .btn-primary {
  color: #fff;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  &:hover,
  &:focus,
  &:not(:disabled):not(.disabled):active {
    color: var(--user-highlight-color) !important;
    background-color: #fff;
    border-color: var(--user-highlight-color);
  }
}
::v-deep .btn-inverse {
  color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  &:hover,
  &:focus,
  &:not(:disabled):not(.disabled):active {
    color: #fff;
    background-color: var(--user-highlight-color);
    border-color: var(--user-highlight-color);
  }
}

::v-deep .menu-container {
  .filter-item.filter-selected {
    border: 1px solid var(--user-highlight-color);
    color: var(--user-highlight-color);
  }
  .menu-item.selected {
    color: var(--user-highlight-color);
  }
}
::v-deep .color-1 {
  color: var(--user-highlight-color) !important;
}
::v-deep .overlay .close-modal {
  color: #fff;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
}
::v-deep .overlay .close-modal {
  width: 2.5rem;
  height: 2.5rem;
  color: #fff;
  background-color: var(--user-highlight-color);
  border-color: var(--user-highlight-color);
  &:hover,
  &:focus {
    color: var(--user-highlight-color);
    background-color: #fff;
    border-color: var(--user-highlight-color);
  }
}
::v-deep .badge {
  border: 1px solid var(--user-highlight-color);
  background-color: var(--user-highlight-color);
  color: #fff;
  &.badge-inverse {
    color: var(--user-highlight-color);
    background-color: #fff;
  }
}
.r-scr {
  font-size: 1rem;
}
</style>
<script>
import pageMixin from "../../mixins/pageMixin";
import menuMixin from "../../mixins/menuMixin";
import dateTimeMixin from "../../mixins/dateTimeMixin";

import notification from "../../components/notification/General";
import gallery from "../../components/menu/view/Gallery";
import socialLinks from "../../components/menu/view/SocialLinks";
import socialShare from "../../components/menu/view/SocialShare";
import openingHours from "../../components/menu/view/OpeningHours";
import reviews from "../../components/menu/view/Reviews";
import menuTitle from "../../components/menu/view/Title";
import menuFunctions from "../../components/menu/view/Functions";
import menuNavigation from "../../components/menu/view/Navigation";
import menuFilters from "../../components/menu/view/Filters";
import viewItem from "../../components/menu/view/ViewItem";
import menuCategory from "../../components/menu/view/Category";
import contactUser from "../../components/menu/view/Contact";
import claimMenu from "../../components/menu/view/Claim";
import subscribeCustomer from "../../components/menu/view/Subscribe";
import unSubscribeCustomer from "../../components/menu/view/UnSubscribe";
import aboutUser from "../../components/menu/view/About";

import addItem from "../../components/menu/admin/AddItem";
import addCategory from "../../components/menu/admin/AddCategory";
import editCategory from "../../components/menu/admin/EditCategory";
import editItem from "../../components/menu/admin/EditItem";

import editMenuItemOptions from "../../components/menu/admin/EditMenuItemOptions";

import editMenuItemCrossSellGroups from "../../components/menu/admin/EditMenuItemCrossSellGroups.vue";

import guestRegister from "../../components/guest/register";

import sharedFooter from "../../components/shared/footer";
import sharedHeader from "../../components/shared/header";
import formLoader from "../../components/form/FormLoader";

import cartButton from "../../components/cart/CartButton";
import viewOrder from "../../components/cart/Order";
import orderSuccessNotification from "../../components/cart/OrderNotification.vue";
import feedBackForm from "../../components/feedback/form.vue";

import draggable from "vuedraggable";
import moment from "moment-timezone";
export default {
  mounted() {
    //Dont do if mock menu for settings (menu Design)
    if (!this.mockMenu) {
      this.setAppProcessing(true);
      this.getUser().then((result) => {
        this.getMenu(this.$route.params.userSlug).then((result) => {
          this.checkRoute(this.$route);
          document.addEventListener("scroll", this.handleScroll);
          this.handleScroll();
          this.loadUserFont(this.menu.user);
          this.getCart();
          this.setAppProcessing(false);
        });
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      stickyHeader: false,
      selectedCategory: null,
      updated: false,
      dineInIntent: false,
      filters: {},
      guestRegisterViewed: false,
      accordionItems: {
        openingHours: { open: false },
        shareMenu: { open: false },
        reviews: { open: true },
      },
    };
  },
  methods: {
    checkRoute: function (to) {
      if (this.selectedMenuItemId) {
        this.scrollTo(this.selectedMenuItemId, 500);
      }

      if (this.isMenuOwner) {
        switch (to.name) {
          case "userIndex":
            this.$router
              .push({
                name: "menuIndex",
                params: {
                  userSlug: this.menu.user.slug,
                },
              })
              .catch(() => {});
            break;
          case "menuItemOptions":
            this.openModal("editMenuItemOptions");
            break;
          case "menuItemCrossSellGroups":
            this.openModal("editMenuItemCrossSellGroups");
            break;
          case "menuItemsAdd":
            this.openModal("addItem");
            break;
          case "menuItem":
            this.openModal("viewItem");
            break;
          case "menuItemEdit":
            this.openModal("editItem");
            break;
          case "menuCategoriesAdd":
            this.openModal("addCategory");
            break;
          case "menuCategoriesEdit":
            this.openModal("editCategory");
            break;
          case "menuContact":
            this.openModal("contactUser");
            break;
          case "menuClaim":
            this.openModal("claimMenu");
            break;
          case "menuSubscribe":
            this.openModal("subscribeCustomer");
            break;
          case "menuUnSubscribe":
            this.openModal("unSubscribeCustomer");
            break;
          case "menuAbout":
            this.openModal("aboutUser");
            break;
          case "customerCart":
            this.getCart();
            this.openModal("customerCart");
            break;
          default:
            this.closeModals();
        }
      } else {
        switch (to.name) {
          case "menuIndex":
            this.$gtag.pageview({
              page_title: this.rawMenu.user.name + " Menu",
            });
            //open register
            if (this.menu.user.guest_register == 1) {
              this.getGuest(this.$route.params.userSlug).then((result) => {
                if (!this.guest.registered && !this.guestRegisterViewed) {
                  this.openModal("guestRegister");
                  this.guestRegisterViewed = true;
                }
              });
            }
            break;
          case "userIndex":
            this.$router
              .push({
                name: "menuIndex",
                params: {
                  userSlug: this.menu.user.slug,
                },
              })
              .catch(() => {});
            break;
          case "menuRegister":
            this.$router
              .push({
                name: "menuIndex",
                params: {
                  userSlug: this.menu.user.slug,
                },
              })
              .catch(() => {});
            break;
          case "menuItem":
            this.openModal("viewItem");
            break;
          case "menuContact":
            this.openModal("contactUser");
            break;
          case "menuClaim":
            this.openModal("claimMenu");
            break;
          case "menuSubscribe":
            this.openModal("subscribeCustomer");
            break;
          case "menuUnSubscribe":
            this.openModal("unSubscribeCustomer");
            break;
          case "menuAbout":
            this.openModal("aboutUser");
            break;
          case "customerCart":
            this.getCart();
            this.openModal("customerCart");
            break;
          default:
            this.closeModals();
        }
      }
    },
    handleScroll(event) {
      if (this.$route.name == "menuIndex") {
        if (this.menu && this.menu.categories && this.$refs.stickyHeader) {
          let _self = this;
          _.forEach(this.menu.categories, function (cValue, cKey) {
            let el = document.getElementById(
              _self.categoryIdPrefix + cValue.slug
            );
            if (
              el.getBoundingClientRect().y >
              _self.$refs.stickyHeader.offsetHeight
            ) {
              if (
                el.getBoundingClientRect().y >
                  _self.$refs.stickyHeader.offsetHeight &&
                el.getBoundingClientRect().y <
                  _self.$refs.stickyHeader.offsetHeight + 200
              ) {
                _self.selectedCategory = el.dataset.category;
              }
            }
          });
        }
      }
      if (this.$refs.header) {
        if (this.stickyHeader) {
          if (this.$refs.header.getBoundingClientRect().y == 0) {
            this.stickyHeader = false;
          }
        } else {
          if (this.$refs.header.getBoundingClientRect().y < -51) {
            this.stickyHeader = true;
          }
        }
      }
    },
    updateFilters: function (filters) {
      this.filters = filters;
    },
    isValidJson: function (str) {
      if (!str) {
        return false;
      }
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    toggleAccordionItem: function (item) {
      if (item.open) {
        item.open = false;
      } else {
        item.open = true;
      }
    },
    getJSONLDFormattedHours: function (abv, obj) {
      if (!obj.open) {
        obj.open = "09:00";
      }
      if (!obj.close) {
        obj.close = "17:00";
      }
      return (
        abv +
        " " +
        moment(obj.open, "HHmm").format("HH:mm") +
        "-" +
        moment(obj.close, "HHmm").format("HH:mm")
      );
    },
  },
  computed: {
    // menu view for this page
    menu: function () {
      if (this.rawMenu) {
        let filteredMenu = _.cloneDeep(this.rawMenu);
        let _self = this;

        if (filteredMenu.categories) {
          //menu owner duplicated because it is computed i.e too much processing
          let isMenuOwner = false;
          if (
            this.user &&
            this.user.id &&
            this.user.id == filteredMenu.user.id
          ) {
            isMenuOwner = true;
          }
          /*** Filter Categories */
          _.remove(filteredMenu.categories, function (el) {
            let removeCategory = false;

            //if category has time restrictions
            if (el.is_time_restricted == 1 && !isMenuOwner) {
              var nwdate = moment().format("YYYY-MM-DD");
              let tf = moment.tz(
                nwdate + " " + el.time_from,
                "YYYY-MM-DD HH:mm:ss",
                filteredMenu.user.timezone.name
              );

              let tt = moment.tz(
                nwdate + " " + el.time_to,
                "YYYY-MM-DD HH:mm:ss",
                filteredMenu.user.timezone.name
              );

              if (tf.isValid() && tt.isValid) {
                let now = moment.tz(filteredMenu.user.timezone.name);
                if (!now.isBetween(tf, tt)) {
                  removeCategory = true;
                }
              }
            }

            //if category i snot published
            if (!el.is_published && !isMenuOwner) {
              removeCategory = true;
            }

            return removeCategory;
          });

          /*** Filter Items */
          _.forEach(filteredMenu.categories, function (cValue, cKey) {
            _.remove(cValue.items, function (el) {
              let removeItem = false;

              //if item has time restrictions
              if (el.is_time_restricted == 1 && !isMenuOwner) {
                var nwdate = moment().format("YYYY-MM-DD");
                let tf = moment.tz(
                  nwdate + " " + el.time_from,
                  "YYYY-MM-DD HH:mm:ss",
                  filteredMenu.user.timezone.name
                );

                let tt = moment.tz(
                  nwdate + " " + el.time_to,
                  "YYYY-MM-DD HH:mm:ss",
                  filteredMenu.user.timezone.name
                );

                if (tf.isValid() && tt.isValid) {
                  let now = moment.tz(filteredMenu.user.timezone.name);
                  if (!now.isBetween(tf, tt)) {
                    removeItem = true;
                  }
                }
              }

              _.forEach(_self.filters, function (fValue, fKey) {
                //if filter is in selection (selected)
                if (fValue.selected) {
                  if (!el[fKey]) {
                    removeItem = true;
                    return;
                  }
                }
              });

              //if item is not published
              if (!el.is_published && !isMenuOwner) {
                removeItem = true;
              }

              return removeItem;
            });
          });
        }
        return filteredMenu;
      }
      return null;
    },
    metaTags: function () {
      let tags = {
        title: "Menu",
        description: "",
        scripts: [],
        links: [],
        titleTemplate: "%s | Happy Menu",
      };
      if (this.rawMenu) {
        tags.title = this.rawMenu.user.name + " Menu";
        tags.description =
          this.rawMenu.user.name +
          " " +
          this.rawMenu.user.address_neighborhood_name +
          "Menu. " +
          this.rawMenu.user.about_text;
        let cuisines = this.rawMenu.user.cuisines.map(({ label }) => label);

        let openingHours = [];
        if (this.rawMenu.user.business_hours) {
          let hours = JSON.parse(this.rawMenu.user.business_hours);
          _self = this;

          _.forEach(hours.week_days, function (value, key) {
            if (value[0].isOpen) {
              openingHours.push(
                _self.getJSONLDFormattedHours(
                  key.charAt(0).toUpperCase() + key.slice(1, 2),
                  value[0]
                )
              );
            }
          });
        }

        let jsonld = {
          "@context": "http://schema.org",
          "@type": "FoodEstablishment",
          name: this.rawMenu.user.name,
          description: this.rawMenu.user.about_text
            ? this.rawMenu.user.about_text
            : "",
          url: "https://www.happymenu.co/" + this.rawMenu.user.slug,
          image:
            "https://www.happymenu.co" +
            "/storage/logos/" +
            this.rawMenu.user.id +
            "/medium/" +
            this.rawMenu.user.logo,
          address: {
            "@type": "PostalAddress",
            addressLocality: this.rawMenu.user.address_city_name
              ? this.rawMenu.user.address_city_name
              : "",
            addressRegion: this.rawMenu.user.state.name
              ? this.rawMenu.user.state.name
              : "",
            postalCode: this.rawMenu.user.address_zip
              ? this.rawMenu.user.address_zip
              : "",
            streetAddress: this.rawMenu.user.address_street_name
              ? this.rawMenu.user.address_street_name
              : "",
          },
          openingHours: openingHours,
          servesCuisine: cuisines,
          hasMenu: {},
        };
        jsonld["hasMenu"]["@type"] = "Menu";
        jsonld["hasMenu"]["hasMenuSection"] = [];
        let _self = this;
        _.forEach(this.rawMenu.categories, function (value) {
          tags.description += value.name + ", ";
          if (value.is_published) {
            let section = {
              "@type": "MenuSection",
              name: value.name,
              description: value.description ? value.description : "",
            };
            section["hasMenuItem"] = [];
            _.forEach(value.items, function (item) {
              if (item.is_published) {
                let foodItem = {
                  "@type": "MenuItem",
                  name: item.name,
                  description: item.description ? item.description : "",
                  image: item.image
                    ? "https://www.happymenu.co/storage/menu_item_image/" +
                      _self.rawMenu.user.id +
                      "/medium/" +
                      item.image
                    : "",
                };
                foodItem["offers"] = [];
                if (item.prices && item.prices[0]) {
                  foodItem["offers"].push({
                    "@type": "Offer",
                    price: item.prices[0] ? item.prices[0].amount / 100 : "",
                    priceCurrency: _self.rawMenu.user.currency.code,
                  });
                }
                section["hasMenuItem"].push(foodItem);
              }
            });

            jsonld["hasMenu"]["hasMenuSection"].push(section);
          }
        });

        tags.scripts = [
          {
            type: "application/ld+json",
            json: jsonld,
          },
        ];
        tags.links = [];
      }
      return tags;
    },
    validWebsiteUrl: function () {
      if (
        this.rawMenu.user.website_url.includes("http://") ||
        this.rawMenu.user.website_url.includes("https://")
      ) {
        return this.rawMenu.user.website_url;
      }
      return "https://" + this.rawMenu.user.website_url;
    },
    mapSource: function () {
      return this.getMap(this.rawMenu.user.address_directions);
    },
    reviewScore: function () {
      if (this.rawMenu.user.reviews) {
        let score = 0;
        let reviewSourceCount = 0;
        _.forEach(this.rawMenu.user.reviews, function (value) {
          score += value.rating;
          reviewSourceCount++;
        });
        return (score / reviewSourceCount).toFixed(1);
      }
      return this.getMap(this.rawMenu.user.address_directions);
    },
  },
  watch: {
    $route(to, from) {
      this.checkRoute(to);
    },
  },
  props: {
    mockMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    notification,
    menuTitle,
    menuFunctions,
    menuNavigation,
    menuFilters,
    menuCategory,
    sharedFooter,
    sharedHeader,
    addCategory,
    editCategory,
    addItem,
    guestRegister,
    editItem,
    viewItem,
    editMenuItemOptions,
    editMenuItemCrossSellGroups,
    contactUser,
    claimMenu,
    subscribeCustomer,
    unSubscribeCustomer,
    aboutUser,
    draggable,
    formLoader,
    socialLinks,
    gallery,
    socialShare,
    openingHours,
    reviews,
    cartButton,
    viewOrder,
    orderSuccessNotification,
    feedBackForm,
  },
  mixins: [pageMixin, menuMixin, dateTimeMixin],
};
</script>
